module.exports = __webpack_public_path__ + "static/img/hui.3f5496f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/game/hui.png
// module id = iwW4
// module chunks = 2